import { Component, OnInit } from "@angular/core";
import { GlobalService } from "../../../../../_global/global.service";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { B2CRateMasterService } from "../../../../../_services/Master/b2cRateMaster.service";
import { ProductSlab } from "./../../../../../_models/master/ProductSlab";
import { B2CRateRule } from "./../../../../../_models/master/B2CRate";
import { ScriptLoaderService } from "./../../../../../_services/script-loader/script-loader.service";

declare var swal: any;

@Component({
    selector: "consumer-slab-rate-approval",
    templateUrl: "./consumer-slab-rate-approval.component.html",
    styleUrls: ["./consumer-slab-rate-approval.component.scss"],
    providers: [B2CRateMasterService, ScriptLoaderService],
})
export class ConsumerSlabRateMasterComponent implements OnInit {
    constructor(
        private b2cRateService: B2CRateMasterService,
        public _gs: GlobalService,
        private router: Router,
        public _route: ActivatedRoute,
        private _script: ScriptLoaderService,
    ) { }

    approvalOTP: number;
    requestType: string;
    requestId: string;
    otpMessage: string;
    showOTPForm: boolean = true;

    ngOnInit() {
        this._script
            .loadScripts("body", ["assets/vendors/base/vendors.bundle.js"], true)
            .then((result) => { });
        this.requestType = this._route.snapshot.params["requestType"];
        this.requestId = this._route.snapshot.params["requestId"];
        if (this.requestType == "approve") {
            this.rateRuleSlabApproveRequest(this.requestId, this.approvalOTP);
        } else if (this.requestType == "reject") {
            this.rateRuleSlabRejectRequest(this.requestId, this.approvalOTP);
        }
    }

    keyPressNumbers(event) {
        var charCode = event.which ? event.which : event.keyCode;
        // Only Numbers 0-9
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }

    verifyOTP() {
        if (this.approvalOTP) {
            if (this.requestType == "approve") {
                this.rateRuleSlabApproveRequest(this.requestId, this.approvalOTP);
            } else if (this.requestType == "reject") {
                this.rateRuleSlabRejectRequest(this.requestId, this.approvalOTP);
            }
        } else {
            swal("Kindly enter otp");
        }
    }

    rateRuleSlabApproveRequest(reqId, otp) {
        this.b2cRateService.rateRuleSlabApproveRequest(reqId, otp).subscribe(
            (resp) => {
                this.otpMessage = resp["_body"];
                if (this.otpMessage.includes("Successfully APPROVED")) {
                    this.otpMessage = "Successfully APPROVED";
                    this.showOTPForm = false;
                }
            },
            (err) => {
                let respData = err.json();
                swal(respData.message);
            },
        );
    }

    rateRuleSlabRejectRequest(reqId, otp) {
        this.b2cRateService.rateRuleSlabRejectRequest(reqId, otp).subscribe(
            (resp) => {
                this.otpMessage = resp["_body"];
                if (this.otpMessage.includes("Successfully REJECTED")) {
                    this.otpMessage = "Successfully REJECTED";
                    this.showOTPForm = false;
                }
            },
            (err) => {
                let respData = err.json();
                swal(respData.message);
            },
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/pages/admin/Master/b2c-rate-approval/consumer-slab-rate-approval.component.ts